import { render } from "./NegotiationsWar.vue?vue&type=template&id=b74c9696&scoped=true"
import script from "./NegotiationsWar.vue?vue&type=script&lang=js"
export * from "./NegotiationsWar.vue?vue&type=script&lang=js"

import "./NegotiationsWar.vue?vue&type=style&index=0&id=b74c9696&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74c9696"]])

export default __exports__